import React from 'react';
import PropTypes from 'prop-types';

import { Paragraph } from 'components/core/Typography';
import Clock from 'components/svg/Clock';

import './RecentReservations.scss';

export default function RecentReservations({
	location, reservations
}) {
	return (
		<div className="recent-reservations">
			<Paragraph last className="recent-reservations-text">
				<Clock />
				<strong>{reservations} units</strong> reserved in
				{' '}
				<strong>
					{location.city}, {location.fullState}
				</strong>
				{' '}
				yesterday. Reserve now to secure your unit.
			</Paragraph>

		</div>
	);
}

RecentReservations.propTypes = {
	location: PropTypes.shape({
		city: PropTypes.string.isRequired,
		fullState: PropTypes.string.isRequired
	}).isRequired,
	reservations: PropTypes.number.isRequired
};
